import {Form} from './form';
import {FormTypes} from './form-types';
import {Config} from '../config';
import {MultipleContactsValidator} from '../validators/multiple-contacts-validator';
import {Order} from '../config/order';
import { BehaviorSubject } from 'rxjs';
import { LogFailingOnRenderView } from '../view/z-log-failing-on-render-view';

export interface ValidField {
    index: number;
    info: Array<{name: string, isValid: boolean, isRequired: boolean, isPatternValid: boolean}>;}

export class LogFailingOnRenderForm extends Form {

    view: LogFailingOnRenderView = new LogFailingOnRenderView();
    type = FormTypes.LogFailingOnRender;
    fields = [];
    fieldGroup: Node[][] = [];
    validator: MultipleContactsValidator = new MultipleContactsValidator();

    fieldMap : ValidField[] = [];
    fieldChange = new BehaviorSubject(this.fieldMap);

    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
        return Promise.resolve();
    }

    async render() {
        this.view.init();
    }

    renderContact() {

    }

    public submit(order: Order) {

        return Promise.resolve(order);
    }

    validate() {
        return Promise.resolve(true);
    }
}
